import {
  StyledFeaturesList,
  StyledFeaturesListItem,
  StyledFeaturesListItemIcon,
  StyledFeaturesListItemText,
  StyledExcludedIcon,
  StyledIncludedIcon,
} from './styled';

export interface Feature {
  excluded?: true;
  label: string;
}

interface FeaturesListProps {
  features: Feature[];
}

const FeaturesList = ({ features }: FeaturesListProps) => {
  return (
    <StyledFeaturesList>
      {features.map(({ label, excluded }) => (
        <StyledFeaturesListItem key={label}>
          <StyledFeaturesListItemIcon>
            {excluded ? <StyledExcludedIcon /> : <StyledIncludedIcon />}
          </StyledFeaturesListItemIcon>
          <StyledFeaturesListItemText primary={label} />
        </StyledFeaturesListItem>
      ))}
    </StyledFeaturesList>
  );
};

export default FeaturesList;
